import axios from '../axios';
import { TFunction } from 'i18next'
import { ICustomer } from '../../interfaces/i-api-customer'
import { logError } from '../../../shared'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { userManager } from '../../../auth/services/auth.service';
import appConfig from '../../../app.config';
import { User } from 'oidc-client';
import { formatBirthDateWithDashes } from 'auth/utils/authHelpers';


const getBirthDateFormatted = (user: User | null): string => {
    
    const birthDateClaim = user?.profile["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/dateofbirth"]
    const birthDateNumbersOnly = birthDateClaim.replace(/\D/g, "") //in the claims the birth date includes time and also is enclosed with extra quotation marks e.g. ""1999-09-09T00:00:00"""

    const birthDate = formatBirthDateWithDashes(birthDateNumbersOnly)
    return birthDate
}

async function getCustomerService(t: TFunction) {
    const user = await userManager.getUser()
    const customerId = user?.profile.sub
    const birthDate = getBirthDateFormatted(user)

    const response = await axios
        .get<ICustomer>(
            (`${appConfig.customerDataBaseUrl}/api/user/mobileapp/customer?customerId=${customerId}&birthDate=${birthDate}`),
            await getHeadersWithJwtToken()
        ).then((result) => {
            result.data.mobilePhoneNumber =
                result.data.mobilePhoneNumber.startsWith('0049')
                    ? result.data.mobilePhoneNumber.replace(
                            /^(0049)/,
                            '+49'
                      )
                    : result.data.mobilePhoneNumber

            if (!result.data.mobilePhoneNumber.startsWith('+')) {
                result.data.mobilePhoneNumber = `+${result.data.mobilePhoneNumber}`
            }

            return result.data as ICustomer
        })
        .catch((err) => {
            logError(err)
            if (err.response?.status === 404) {
                throw new Error(t('CutomerNotFound'))
            } else {
                throw err
            }
        })
    return response as ICustomer
}

export default getCustomerService;